import { Component } from '@angular/core';
import { UserService } from '../shared/services/user.service';
import { AuthService } from '../shared/services/auth.service';
import { NbMenuItem } from '@nebular/theme';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menuArray" autoCollapse="true"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class PagesComponent {
  
 
  showDB = false;
  showCOM = false;
  showEM = false;
  showSM = false;
  showCM = false;
  showRD = false;
  showFA = false;
  showVH = false;
  showIC = false;
  showIM = false;
  showKITCHEN_STOCK = false;
  showKITCHEN_STOCK_ADD = false;
  showKITCHEN_STOCK_CON = false;
  showKITCHEN_STOCK_BAL = false;
  showKITCHEN_STOCK_REQ = false;
  showSP = false;
  showWM = false;
  showBR = false;
  showGU = false;
  showPO = false;
  showPI = false;
  showPMT = false;
  showBAR = false;
  showQUO = false;
  showGUEST_PUR = false;
  showINV = false;
  showRECEIPT = false;
  showEXP = false;
  showMACC = false;
  showCB_ENTRY = false;
  showCHQ = false;
  showCB_BAL = false;
  showRPT_CB = false;
  showRPT_SB = false;
  showRPT_IB = false;
  showRPT_PUR = false;
  showRPT_SALE = false;
  showRPT_BSALE = false;
  showRPT_ITEM_SALE = false;
  showRPT_EXP = false;
  showRPT_CON = false;
  showRPT_FA = false;
  showRPT_PNL = false;
  showUSER = false;
  showSETTINGS = false;
  showBACKUP = false;



 

  menuArray :  NbMenuItem[]=[];

  roles: string[];
  username: string;


  constructor (private userService: UserService,
    private authService: AuthService,
    private router : Router,
    ){}



ngOnInit() {

this.getUserLoggedData();
this.getUserPermissionByUserName();
this.getUserControlPermissionByUserName();

}

getUserLoggedData() : void {
  this.username = this.authService.getUserLoggedIn();
}



 
  getUserPermissionByUserName(){
    this.roles = [];
     var data = [];
     if(this.username){
       this.userService.getUserPermission(this.username).subscribe(
         (res)=> {
           if(res[0]){
             const values = Object.values(res[0])
             for (var value of values) {
               data.push(value);                                                  
             }
   
             this.roles = data.slice(2,49); 
             this.assignRoles(this.roles);  
            }
         },
         (err) => {          
           console.log(err);
         },
 
       )
     }   
        
   }

   
  getUserControlPermissionByUserName(){ 
      this.userService.getControlPermission(this.username).subscribe(
        (res)=> {       
          this.authService.controlPermissionArray  = res.map((obj)=> {
            return {
                    username: obj.UserName,
                    moduleCode : obj.ModuleCode,
                    module: obj.Module,
                    read: obj.ReadAccess==='0'? 0: obj.ReadAccess,
                    create: obj.CreateAccess==='0' ? 0: obj.CreateAccess, 
                    approve:  obj.ApproveAccess==='0' ? 0: obj.ApproveAccess,  
                    delete: obj.DeleteAccess==='0' ? 0: obj.DeleteAccess,
                    createdBy: obj.CreatedBy
                  };
            }); 
   
        },
        (err) => {
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        });

      
    
       

  }
  

  assignRoles(roles: any []){

    this.showDB=!!roles[0];
    this.showCOM=!!roles[1];
    this.showEM=!!roles[2];
    this.showSM=!!roles[3];
    this.showCM=!!roles[4];
    this.showRD=!!roles[5];
    this.showFA=!!roles[6];
    this.showVH=!!roles[7];
    this.showIC=!!roles[8];
    this.showIM=!!roles[9];
    this.showKITCHEN_STOCK=!!roles[10];
    this.showKITCHEN_STOCK_ADD=!!roles[11];
    this.showKITCHEN_STOCK_CON=!!roles[12];
    this.showKITCHEN_STOCK_BAL=!!roles[13];
    this.showKITCHEN_STOCK_REQ=!!roles[14];
    this.showSP=!!roles[15];
    this.showWM=!!roles[16];
    this.showBR=!!roles[17];
    this.showGU=!!roles[18];
    this.showPO=!!roles[19];
    this.showPI=!!roles[20];
    this.showPMT=!!roles[21];
    this.showBAR=!!roles[22];
    this.showQUO=!!roles[23];
    this.showGUEST_PUR=!!roles[24];
    this.showINV=!!roles[25];
    this.showRECEIPT=!!roles[26];
    this.showEXP=!!roles[27];
    this.showMACC=!!roles[28];
    this.showCB_ENTRY=!!roles[29];
    this.showCHQ=!!roles[30];
    this.showCB_BAL=!!roles[31];
    this.showRPT_CB=!!roles[32];
    this.showRPT_SB=!!roles[33];
    this.showRPT_IB=!!roles[34];
    this.showRPT_PUR=!!roles[35];
    this.showRPT_SALE=!!roles[36];
    this.showRPT_BSALE=!!roles[37];
    this.showRPT_ITEM_SALE=!!roles[38];
    this.showRPT_EXP=!!roles[39];
    this.showRPT_CON=!!roles[40];
    this.showRPT_FA=!!roles[41];
    this.showRPT_PNL=!!roles[42];
    this.showUSER=!!roles[43];
    this.showSETTINGS=!!roles[44];
    this.showBACKUP=!!roles[45];
    



    
     
     if(this.showDB){
      this.router.navigate(['/pages/dashboard']);
      }
     
     this.menuArray = [
      {
        title: 'Dashboard',
        icon: 'keypad-outline',
        link: './dashboard',
        home: true,
        hidden:  !this.showDB,
      },
      
      {
        title: 'Master Files',
        icon: 'grid-outline',
        hidden:  !this.showCOM && !this.showEM && !this.showSM && !this.showCM && !this.showRD  && !this.showFA  && !this.showVH,
        children: [
          {
            title: 'Company Profile',
            link: './master-files/company-profile',
            hidden:  !this.showCOM,
          },
          {
            title: 'Employee Master',
            link: './master-files/employee-list',
            hidden:  !this.showEM,
          },
          {
            title: 'Supplier Master',
            link: './master-files/supplier-list',
            hidden:  !this.showSM,
          },
          {
            title: 'Guest Register',
            link: './master-files/customer-list',
            hidden:  !this.showCM,
          },
          {
            title: 'Room Details',
            link: './master-files/room-details-list',
            hidden:  !this.showRD,
          },
          {
            title: 'Fixed Asset Register',
            link: './master-files/fixed-asset-list',
            hidden:  !this.showFA,
          },
          {
            title: 'Vehicle Register',
            link: './master-files/vehicle-register-list',
            hidden:  !this.showVH,
          },
        ],
      },

    {
        title: 'Inventory',
        icon: 'layers-outline',
        hidden:  !this.showIC && !this.showIM ,
        children: [
          {
            title: 'Item Category',
            link: './products/item-category',
            hidden:  !this.showIC,
          },
          {
            title: 'Item Master',
            link: './products/item-list',
            hidden:  !this.showIM,
          },
        ],
      },

      {
        title: 'Kitchen Stocks',
        icon: 'shopping-cart-outline',
        hidden:  !this.showKITCHEN_STOCK && !this.showKITCHEN_STOCK_ADD &&  !this.showKITCHEN_STOCK_CON && !this.showKITCHEN_STOCK_BAL && !this.showKITCHEN_STOCK_REQ,
        children: [
          {
            title: 'Kitchen Stocks',
            link: './kitchen-stocks/kitchen-stock-list',
            hidden:  !this.showKITCHEN_STOCK,
          },
          {
            title: 'Add Stock',
            link: './kitchen-stocks/add-stock-list',
            hidden:  !this.showKITCHEN_STOCK_ADD,
          },
          {
            title: 'Daily Consumption',
            link: './kitchen-stocks/consumption-list',
            hidden:  !this.showKITCHEN_STOCK_CON,
          },
          {
            title: 'Kitchen Stock Balance',
            link: './kitchen-stocks/kitchen-stock-bal',
            hidden:  !this.showKITCHEN_STOCK_BAL,
          },
          {
            title: 'Stock Requirements',
            link: './kitchen-stocks/stock-requirement-list',
            hidden:  !this.showKITCHEN_STOCK_REQ,
          },

        ],
      },

      {
        title: 'Administration',
        icon: 'edit-2-outline',
        hidden:  !this.showSP && !this.showWM && !this.showBR  && !this.showGU,
        children: [
          {
            title: 'Solar Power Mgt',
            link: './administration/solar-power-list',
            hidden:  !this.showSP,
          },
          {
            title: 'Water Meter Reading',
            link: './administration/water-meter-list',
            hidden:  !this.showWM,
          },
          {
            title: 'Bike Rent',
            link: './administration/bike-rent-list',
            hidden:  !this.showWM,
          },
          {
            title: 'Generator Usage',
            link: './administration/generator-usage-list',
            hidden:  !this.showGU,
          },
          {
            title: 'Water Tank',
            link: './administration/water-tank-list',
            hidden:  !this.showGU,
          },
        ],
      },

      {
        title: 'Purchase',
        icon: 'shopping-cart-outline',
        hidden:  !this.showPO && !this.showPI && !this.showPMT,
        children: [
          {
            title: 'Purchase Order',
            link: './purchase/purchase-order-list',
            hidden:  !this.showPO,
          },
          {
            title: 'Purchase Invoice',
            link: './purchase/purchase-invoice-list',
            hidden:  !this.showPI,
          },
          {
            title: 'Payment',
            link: './purchase/payment-list',
            hidden:  !this.showPMT,
          },
        ],
      },
      // {
      //   title: 'Bar',
      //   icon: 'flash-outline',
      //   hidden:  !this.showBAR,
      //   children: [
      //     {
      //       title: 'Bar Invoice',
      //       link: './customer/bar-invoice-list',
      //       hidden:  !this.showBAR,
      //     },
      //   ],
      // },
      {
        title: 'Sale',
        icon: 'file-text-outline',
        hidden:  !this.showQUO &&  !this.showINV &&  !this.showRECEIPT,
        children: [
          {
            title: 'Bar Invoice',
            link: './customer/bar-invoice-list',
            hidden:  !this.showBAR,
          },
          {
            title: 'Quotation',
            link: './customer/quotation-list',
            hidden:  !this.showQUO,
          },
          {
            title: 'Guest Purchases',
            link: './customer/guest-purchase-list',
            hidden:  !this.showGUEST_PUR,
          },
          {
            title: 'Invoice',
            link: './customer/invoice-list',
            hidden:  !this.showINV,
          },
          {
            title: 'Receipt',
            link: './customer/receipt-list',
            hidden:  !this.showRECEIPT,
          },
        ],
      },
     
      {
        title: 'Expense',
        icon: 'browser-outline',
        link: './expenses/expense-list',
        hidden:  !this.showEXP,
      },
      {
        title: 'Cash & Bank',
        icon: 'credit-card-outline',
        hidden:  !this.showMACC && !this.showCB_ENTRY&& !this.showCHQ && !this.showCB_BAL,
        children: [
          {
            title: 'Manage Accounts',
            link: './cash&banks/manage-accounts',
            hidden:  !this.showMACC,
          },
          {
            title: 'Cash & Bank Entry',
            link: './cash&banks/cash&bank-entry-list',
            hidden:  !this.showCB_ENTRY,
          },
          {
            title: 'Draw a Cheque',
            link: './cash&banks/draw-cheque-list',
            hidden:  !this.showCHQ,
          },
          // {
          //   title: 'Cheques',
          //   link: './cash&banks/cheque-list',
          //   hidden:  !this.showCHQ,
          // },
          {
            title: 'Cash & Bank Balances',
            link: './cash&banks/cash-flow-statement',
            hidden:  !this.showCB_BAL,
          },
        ],
      },
      {
        title: 'Reports',
        icon: 'pie-chart-outline',
        hidden:  !this.showRPT_CB &&  !this.showRPT_SB &&  !this.showRPT_IB && !this.showRPT_PUR &&  !this.showRPT_SALE &&  !this.showRPT_BSALE && !this.showRPT_ITEM_SALE &&  !this.showRPT_EXP &&  !this.showRPT_CON &&  !this.showRPT_FA &&  !this.showRPT_PNL,
        children: [
          {
            title: 'Customer Outstanding Report',
            link: './reports/customer-outstanding-report',
            hidden:  !this.showRPT_CB,
          },
          {
            title: 'Supplier Outstanding Report',
            link: './reports/supplier-outstanding-report',
            hidden:  !this.showRPT_SB,
          },
          {
            title: 'Inventory Balance',
            link: './reports/inventory-balance',
            hidden:  !this.showRPT_IB,
          },
          {
            title: 'Purchase Report',
            link: './reports/purchase-report',
            hidden:  !this.showRPT_PUR,
          },
          {
            title: 'Sales Report',   
            link: './reports/sales-report',        
            hidden:  !this.showRPT_SALE,
          },
          {
            title: 'Bar Sales Report',   
            link: './reports/bar-sales-report',        
            hidden:  !this.showRPT_BSALE,
          },
          {
            title: 'Item Sales Report',   
            link: './reports/item-sales-report',     
            hidden:  !this.showRPT_ITEM_SALE,
          },
          {
            title: 'Expense Report',
            link: './reports/expense-report',
            hidden:  !this.showRPT_EXP,
          },
          {
            title: 'Consumption Report',
            link: './reports/consumption-report',
            hidden:  !this.showRPT_CON,
          },
          {
            title: 'Fixed Asset Report',
            link: './reports/fixed-asset-report',
            hidden:  !this.showRPT_FA,
          },
          {
            title: 'Profit & Loss Statement',
            link: './reports/profit-and-loss-statement',
            hidden:  !this.showRPT_PNL,
          },
        ],
      },
      {
        title: 'Users',
        icon: 'person-done-outline',
        hidden:  !this.showUSER,
        children: [
          {
            title: 'User Types',
            link: './user-management/user-types',
          },
          {
            title: 'User',
            link: './user-management/user-list',
          },
          {
            title: 'User Permission',
            link: './user-management/user-permission',
          },
          {
            title: 'Reset Password',
            link: './user-management/reset-password-request-list',
          },
        ],
      },
      {
        title: 'Settings',
        icon: 'settings-2-outline',
        link: './settings',
        hidden:  !this.showSETTINGS,
      },

      {
        title: 'Backup',
        icon: 'hard-drive',
        link: './backup',
        hidden:  !this.showBACKUP,
      },

     ]
     
   }

}
